import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import ScrollableTable from '../../common/ScrollableTable';

interface TableViewProps {
    columns: string[];
    rows: (string | number)[][];
}

export default function TableView({ columns, rows }: TableViewProps) {
    return (
        <ScrollableTable>
            <Table size="small" aria-label="chart data table">
                <TableHead>
                    <TableRow>
                        {columns.map(c => <TableCell key={c}><strong>{c}</strong></TableCell>)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((r, i) => (
                        <TableRow key={i}>
                            {r.map((cell, j) => <TableCell key={j}>{cell}</TableCell>)}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </ScrollableTable>
    );
}
